import { render, staticRenderFns } from "./aRmsRevenueDaysToReservationChart.vue?vue&type=template&id=72071faa"
import script from "./aRmsRevenueDaysToReservationChart.vue?vue&type=script&lang=js"
export * from "./aRmsRevenueDaysToReservationChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports